import './loader-bars.svg';
import 'gridstrap/svg-symbols/close.svg?sprite';
import 'gridstrap/svg-symbols/chevron-right-circle.svg?sprite';

import './screenshot-carousel.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSScreenshotCarousel } from './screenshot-carousel';
import { GSScreenshotCarouselImage } from './screenshot-carousel-image';
import { GSScreenshotCarouselService } from './screenshot-carousel-service';

components.register({
	selector: '.gs-ScreenshotCarousel',
	controller: GSScreenshotCarousel
});

components.register({
	selector: '.gs-ScreenshotCarousel-item',
	controller: GSScreenshotCarouselImage
})

export const screenshotCarousel = new GSScreenshotCarouselService();
